import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible'
import axios from 'axios';
Vue.prototype.$axios = axios;
Vue.config.productionTip = false

let env = 'prod'

if (env == 'sit') {
  Vue.prototype.$url="https://mpsit40.ibaiqiu.com/service-zuul/shortLink/analysisShortLink";
  Vue.prototype.$beforeUrl="https://mpsit40.ibaiqiu.com/service-zuul/ads/getAdsUrlScheme";
}

if (env == 'uat') {
  Vue.prototype.$url="https://mpuat40.ibaiqiu.com/service-zuul/shortLink/analysisShortLink";
  Vue.prototype.$beforeUrl="https://mpuat40.ibaiqiu.com/service-zuul/ads/getAdsUrlScheme";
}

if (env == 'prod') {
  Vue.prototype.$url="https://eshop.ibaiqiu.com/service-zuul/shortLink/analysisShortLink";
  Vue.prototype.$beforeUrl="https://eshop.ibaiqiu.com/service-zuul/ads/getAdsUrlScheme";
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
